import React from 'react';
import { motion } from 'framer-motion';
export function Pricing() {
  const plans = [{
    time: '30 Minutes',
    description: 'Focused, high-intensity. Targets performance, strength, and coordination.',
    popular: false
  }, {
    time: '60 Minutes',
    description: 'Full in-depth training: strength, speed, agility, and sport-specific drills.',
    popular: true
  }, {
    time: '90 Minutes',
    description: 'Go all in. Advanced performance, skill refinement, cognitive training, and recovery.',
    popular: false
  }];
  return <section className="py-20 md:py-28 relative bg-sep-black overflow-hidden" style={{
    backgroundImage: 'repeating-linear-gradient(45deg, rgba(255,255,255,0.02) 0px, rgba(255,255,255,0.02) 2px, transparent 2px, transparent 10px)'
  }} data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-187">
        <div className="text-center mb-16" data-id="element-188">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-white uppercase mb-4" data-id="element-189">
            CHOOSE YOUR SESSION
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-gray-400 text-lg" data-id="element-190">
            Tailored training durations to fit your goals and schedule.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto items-center" data-id="element-191">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`relative bg-white/5 backdrop-blur-sm rounded-xl p-8 flex flex-col h-full border ${plan.popular ? 'border-sep-red shadow-[0_0_30px_rgba(198,40,40,0.15)] md:-mt-8 md:mb-8 z-10' : 'border-white/10'}`} data-id="element-192">
              {plan.popular && <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-sep-red text-white text-xs font-bold uppercase tracking-wider py-1 px-4 rounded-full" data-id="element-193">
                  Most Popular
                </div>}

              <div className="text-center mb-8" data-id="element-194">
                <h3 className="font-heading font-bold text-3xl text-white mb-2" data-id="element-195">
                  {plan.time}
                </h3>
                <div className="text-sep-red font-bold text-xl" data-id="element-196">
                  Contact for Pricing
                </div>
              </div>

              <p className="text-gray-300 text-center mb-10 flex-grow" data-id="element-197">
                {plan.description}
              </p>

              <a href="#contact" className={`w-full py-4 px-6 rounded-md font-bold text-center transition-colors ${plan.popular ? 'bg-sep-red hover:bg-sep-red-dark text-white' : 'bg-white/10 hover:bg-white/20 text-white'}`} data-id="element-198">
                Book Now
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}